import React, { useEffect } from 'react'
import styled from 'styled-components'
import { AlertType, AlertTypes } from './Alert.types'
import { CloseIcon } from '../Icon/CloseIcon'
import { STYLES } from '../../static/style'

const PADDING = '.5rem'

const StyledCloseIcon = styled(CloseIcon)`
  margin-left: 1rem;
  cursor: pointer;
`
StyledCloseIcon.displayName = 'CloseIcon'

const StyledAlert = styled.div`
  padding: ${PADDING};
  display: flex;
  align-items: center;
  margin: 1rem auto;
  border-radius: ${STYLES.BORDER_RADIUS};
  color: ${STYLES.COLOR_WHITE};
  background-color: ${({ type }: { type: AlertType }) =>
    ({
      [AlertType.SUCCESS]: STYLES.COLOR_ALANTIS_GREEN,
      [AlertType.ERROR]: STYLES.COLOR_VIVID_RED,
      [AlertType.URGENT]: STYLES.COLOR_VIVID_RED,
      [AlertType.WARNING]: STYLES.COLOR_BUTTERCUP,
      [AlertType.INFO]: STYLES.COLOR_BOSTON_BLUE,
    }[type])};
`

const Alert: React.FC<AlertTypes> = ({
  children,
  onCloseClick,
  type,
  onMounted,
}) => {
  useEffect(() => {
    onMounted()
  }, [onMounted])
  return (
    <StyledAlert type={type}>
      {children}
      <StyledCloseIcon onClick={onCloseClick} />
    </StyledAlert>
  )
}

export { Alert }
